import { TemplateId } from "../../globalTypes";

export const getFavouriteTemplates = () => `api/FavouriteTemplates/ByUser`;
export const addFavouriteTemplate = (templateId: TemplateId) =>
  `api/FavouriteTemplates/ByTemplateId/${templateId}`;
export const removeFavouriteTemplate = (templateId: TemplateId) =>
  `api/FavouriteTemplates/ByTemplateId/${templateId}`;
export const patchFavouriteTemplate = (templateId: TemplateId) =>
  `api/FavouriteTemplates/${templateId}`;
